import { useMutation, useQueryClient } from '@tanstack/react-query';
import { invalidateWorkLogScopes } from '@/entities/work-log';
import { createWorkLog, updateWorkLog, submitWorkLog } from '../api';

export function useCreateWorkLog() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (params: { logDate: string; content?: string }) =>
      createWorkLog(params.logDate, params.content),
    onSuccess: () => {
      // 개수가 하나 늘어난다 — 여덟 곳 중 `count` 가 필요한 유일한 곳이다.
      // 새 일지는 `DRAFT` 라 `lifetimeStats`(`SUBMITTED` 집계)에는 안 잡힌다.
      // `logDate` 는 오늘이 아닐 수도 있지만 오늘일 때 갱신돼야 하므로 `today` 는 포함한다.
      invalidateWorkLogScopes(queryClient, ['list', 'today', 'count']);
    },
  });
}

export function useUpdateWorkLog() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (params: { id: string; content: string }) =>
      updateWorkLog(params.id, params.content),
    onSuccess: () => {
      // 대상이 `SUBMITTED` 면 서버가 `revisionCount: { increment: 1 }` 을 올리고, 그 합이
      // `lifetimeStats` 다(`worklog.service.ts`). FE 는 대상 상태를 모르므로 포함한다.
      // 개수는 안 바뀐다.
      invalidateWorkLogScopes(queryClient, ['list', 'today', 'lifetimeStats']);
    },
  });
}

export function useSubmitWorkLog() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => submitWorkLog(id),
    onSuccess: () => {
      // 제출이 `SUBMITTED` 집계에 들어간다. 일지 수는 그대로다.
      invalidateWorkLogScopes(queryClient, ['list', 'today', 'lifetimeStats']);
    },
  });
}
